import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BehaviorSubject, merge } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Case, CaseManagerService } from 'src/app/services/case-manager.service';
import { Period } from '../../leadership/moleds/period.enum';
import { LeadershipService } from '../../leadership/services/leadership.service';
import { StatusColor } from '../../shared/models/status-color.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  users = [];

  statisticsInterval = Object.keys(Period);
  selectedInterval = 'monthly';
  periodLabel$ = new BehaviorSubject<string>(this.leadershipService.getIntervalFormattedLabel(this.selectedInterval));

  selectedCase: Case = null;
  assignToControl = new FormControl();
  reassignToControl = new FormControl();

  // chartOptions = {
  //   chart: {
  //     backgroundColor: '#f6f6f6',
  //     margin: [0, 0, 0, 0],
  //     spacingTop: 0,
  //     spacingBottom: 0,
  //     spacingLeft: 0,
  //     spacingRight: 0
  //   },
  //   title: {
  //     text: '',
  //     align: 'right',
  //     verticalAlign: 'middle',
  //     x: -12,
  //     style: {
  //       fontSize: '14px'
  //     }
  //   },
  //   accessibility: {
  //     point: {
  //       valueSuffix: '%'
  //     }
  //   },
  //   tooltip: {
  //     pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
  //   },
  //   subtitle: {
  //     text: '?%',
  //     align: 'center',
  //     verticalAlign: 'middle',
  //     y: 16,
  //     x: -52,
  //     style: {
  //       color: '#333',
  //       fontSize: '14px'
  //     }
  //   },
  //   plotOptions: {
  //     pie: {
  //       shadow: false,
  //       center: ['25%', '50%']
  //     }
  //   },
  //   credits: {
  //     enabled: false
  //   },
  //   series: [{
  //     name: 'Number of cases',
  //     type: 'pie',
  //     data: [],
  //     innerSize: '80%',
  //     size: '100%',
  //     dataLabels: {
  //       enabled: false
  //     },
  //     showInLegend: false
  //   }]
  // };
  // statisticsChartOptions = {
  //   chart: {
  //     height: 140,
  //     width: 280
  //   },
  //   legend: {
  //     align: 'right',
  //     verticalAlign: 'middle',
  //     layout: 'vertical',
  //     fontSize: '4px',
  //     width: '40%',
  //     itemStyle: {
  //       textOverflow: 'wrap'
  //     }
  //   },
  //   title: false,
  //   tooltip: {
  //     enabled: false
  //   },
  //   accessibility: {
  //     point: {
  //       valueSuffix: '%'
  //     }
  //   },
  //   credits: {
  //     enabled: false
  //   },
  //   plotOptions: {
  //     pie: {
  //       dataLabels: {
  //         format: '{point.percentage:.1f}%',
  //         distance: -30,
  //         style: {
  //           fontSize: '12px',
  //           color: '#ffffff',
  //           textOverflow: 'clip'
  //         }
  //       },
  //       showInLegend: true,
  //       states: false
  //     }
  //   },
  //   series: [{
  //     type: 'pie',
  //     size: '150%',
  //     data: [
  //       {name: 'Open', y: 0, color: '#1EE994'},
  //       {name: 'Open Reported', y: 0, color: '#2277ED'},
  //       {name: 'Closed', y: 0, color: '#4626A6'},
  //       {name: 'Closed Reported', y: 0, color: '#4626A6'}
  //     ]
  //   }]
  // };
  // chartUnassigned: Chart;
  // chartOverdue: Chart;
  // chartOpen: Chart;
  // chartReported: Chart;
  // chartSolved: Chart;
  // chartStatistics: Chart;

  myCases: Case[];
  pendingCases: Case[];
  personalStatistic = [];
  caseStatistic = [];

  constructor(
    public caseManagerService: CaseManagerService,
    private leadershipService: LeadershipService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {
  }

  async selectCase(newCase: Case) {
    // if (newCase && newCase.code) { // to be used in case the amounts are not available
    //     this.selectedCase = await this.caseManagerService.getCase(newCase.code);
    // }
    this.selectedCase = newCase;
    this.assignToControl.setValue(null, { emitEvent: false });
    this.reassignToControl.setValue(null, { emitEvent: false });
  }

  async loadStatistics() {
    const statistics = await this.caseManagerService.getStatistics(this.selectedInterval);
    return statistics;
  }

  assignToCurrentUser() {
    if (this.selectedCase?.case_code) {
        if (this.selectedCase.case_classification === 'CMS') {
          this.router.navigate(['app/case-manager/user-case/' + this.selectedCase?.case_code.substr(5)]);
         
        } else {
          this.router.navigate(['', 'app', 'case-manager', this.selectedCase?.case_code.substr(5)]);
          
        } 
    } else {
      this.snackBar.open('Please select a case', 'Close', {
        duration: 4000,
      });
    }
  }

  async ngOnInit() { // this needs to get data from the backend
    // let response = await this.caseManagerService.getAssignedCases();
    // this.myCases = response.data;
    // this.myCases = [...response.data_info.high, ...response.data_info.medium, ...response.data_info.low];
    this._initCharts();
    this.users = await this.caseManagerService.getCaseUsers();
    this.subscribeToAssignToChanges();
  }

  subscribeToAssignToChanges() {
    merge(this.assignToControl.valueChanges, this.reassignToControl.valueChanges)
      .pipe(
        filter(userId => !!userId),
        switchMap(userId =>
          this.caseManagerService.assignCaseToUser(this.selectedCase.case_code, userId)
            .pipe(
              tap(assign => {
                this.snackBar.open(`Successfully assigned case to ${ assign.data_info.assigned_to }`, 'Close', {
                  duration: 3500,
                });
                location.reload()
              }),
            ),
        ),
      ).subscribe();
  }

  async _initCharts() {
    const caseStatistics = await this.loadStatistics();
    // ---> this needs some backend resource API?
    // this.chartOptions.title.text = 'Assigned <br/>' + caseStatistics.data_info.personal_statistics.assigned + ' cases';
    // this.chartOptions.series[0].data = [
    //     {
    //         name: 'Assigned',
    //         y: 1000,
    //         color: '#ff0000'
    //     },
    //     {
    //         name: 'Unasssigned',
    //         y: 5200,
    //         color: '#ffffff'
    //     }];
    // this.chartUnassigned = new Chart(_.cloneDeep(this.chartOptions) as Options);
    //
    // this.chartOptions.title.text = 'Solved<br/><b>' + caseStatistics.data_info.personal_statistics.solved.cases + ' cases</b>';
    // this.chartOptions.subtitle.text = caseStatistics.data_info.personal_statistics.solved.percentage.toFixed(0) + '%';
    // this.chartOptions.subtitle.style.color = '#1ee994';
    // this.chartOptions.series[0].data = [
    //     {
    //         name: 'Solved',
    //         y: Number(caseStatistics.data_info.personal_statistics.solved.percentage.toFixed(0)),
    //         color: '#1ee994'
    //     },
    //     {
    //         name: 'Other status',
    //         y: 100 - Number(caseStatistics.data_info.personal_statistics.solved.percentage.toFixed(0)),
    //         color: '#ffffff'
    //     }];
    // this.chartSolved = new Chart(_.cloneDeep(this.chartOptions) as Options);
    //
    // this.chartOptions.title.text = 'Open<br/><b>' + caseStatistics.data_info.personal_statistics.open.cases + ' cases</b>';
    // this.chartOptions.subtitle.text = caseStatistics.data_info.personal_statistics.open.percentage.toFixed(0) + '%';
    // this.chartOptions.subtitle.style.color = '#2277ed';
    // this.chartOptions.series[0].data = [
    //     {
    //         name: 'Open',
    //         y: Number(caseStatistics.data_info.personal_statistics.open.percentage.toFixed(0)),
    //         color: '#2277ed'
    //     },
    //     {
    //         name: 'Other status',
    //         y: 100 - Number(caseStatistics.data_info.personal_statistics.open.percentage.toFixed(0)),
    //         color: '#ffffff'
    //     }];
    // this.chartOpen = new Chart(_.cloneDeep(this.chartOptions) as Options);
    //
    // this.chartOptions.title.text = 'Reported<br/><b>' + caseStatistics.data_info.personal_statistics.reported.cases + ' cases</b>';
    // this.chartOptions.subtitle.text = caseStatistics.data_info.personal_statistics.reported.percentage.toFixed(0) + '%';
    // this.chartOptions.subtitle.style.color = '#4626a6';
    // this.chartOptions.series[0].data = [
    //     {
    //         name: 'Reported',
    //         y: Number(caseStatistics.data_info.personal_statistics.reported.percentage.toFixed(0)),
    //         color: '#4626a6'
    //     },
    //     {
    //         name: 'Other status',
    //         y: 100 - Number(caseStatistics.data_info.personal_statistics.reported.percentage.toFixed(0)),
    //         color: '#ffffff'
    //     }];
    // this.chartReported = new Chart(_.cloneDeep(this.chartOptions) as Options);
    //
    // this.chartOptions.title.text = 'Overdue<br/><b>' + caseStatistics.data_info.personal_statistics.overdue.cases + ' cases</b>';
    // this.chartOptions.subtitle.text = caseStatistics.data_info.personal_statistics.overdue.percentage.toFixed(0) + '%';
    // this.chartOptions.subtitle.style.color = '#4626a6';
    // this.chartOptions.series[0].data = [
    //     {
    //         name: 'Overdue',
    //         y: Number(caseStatistics.data_info.personal_statistics.overdue.percentage.toFixed(0)),
    //         color: '#4626a6'
    //     },
    //     {
    //         name: 'On time',
    //         y: 100 - Number(caseStatistics.data_info.personal_statistics.overdue.percentage.toFixed(0)),
    //         color: '#ffffff'
    //     }];
    // this.chartOverdue = new Chart(_.cloneDeep(this.chartOptions) as Options);
    this.personalStatistic = [
      {
        name: "Solved",
        percentage: Number(caseStatistics.data_info.personal_statistics.solved.percentage.toFixed(0)),
        cases: caseStatistics.data_info.personal_statistics.solved.cases
      },
      {
        name: "Open",
        percentage: Number(caseStatistics.data_info.personal_statistics.open.percentage.toFixed(0)),
        cases: caseStatistics.data_info.personal_statistics.open.cases,
      },
      {
        name: "Reported",
        percentage: Number(caseStatistics.data_info.personal_statistics.reported.percentage.toFixed(0)),
        cases: caseStatistics.data_info.personal_statistics.reported.cases
      },
      {
        name: "Overdue",
        percentage:  Number(caseStatistics.data_info.personal_statistics.overdue.percentage.toFixed(0)),
        cases: caseStatistics.data_info.personal_statistics.overdue.cases
      }
    ]
    this.caseStatistic = [
       {name: "Open", y: Number(caseStatistics.data_info.case_statistics.open.toFixed(1)), color: StatusColor.Open},
       {name: "Open Reported", y: Number(caseStatistics.data_info.case_statistics.open_reported.toFixed(1)), color: StatusColor.Reported},
       {name: "Closed", y: Number(caseStatistics.data_info.case_statistics.closed.toFixed(1)), color: StatusColor.Closed},
       {name: "Closed Reported", y: Number(caseStatistics.data_info.case_statistics.closed_reported.toFixed(1)), color: StatusColor.Solved},
    ];
    //
    // this.statisticsChartOptions.series[0].data[0].y = caseStatistics.data_info.case_statistics.open;
    // this.statisticsChartOptions.series[0].data[1].y = caseStatistics.data_info.case_statistics.open_reported;
    // this.statisticsChartOptions.series[0].data[2].y = caseStatistics.data_info.case_statistics.closed;
    // this.statisticsChartOptions.series[0].data[3].y = caseStatistics.data_info.case_statistics.closed_reported;
    // this.chartStatistics = new Chart(this.statisticsChartOptions as Options);
  }

  changeInterval(interval: string) {
    if (interval === this.selectedInterval) {
      return;
    }
    this.periodLabel$.next(this.leadershipService.getIntervalFormattedLabel(interval));
    this.selectedInterval = interval;
    this._initCharts();
  }
}
